<script lang="ts">
    import { getContext, setContext } from "svelte";
    import { openedMenuStore } from "../../../Stores/MenuStore";
    import AppsLocationIcon from "../../Icons/AppsLocationIcon.svelte";
    import ActionBarButton from "../ActionBarButton.svelte";
    import LL from "../../../../i18n/i18n-svelte";
    import { modalIframeStore, modalVisibilityStore, roomListVisibilityStore } from "../../../Stores/ModalStore";
    import { createFloatingUiActions } from "../../../Utils/svelte-floatingui";

    // The ActionBarButton component is displayed differently in the menu.
    // We use the context to decide how to render it.
    setContext("inMenu", true);

    const inProfileMenu = getContext("profileMenu");

    const [floatingUiRef] = createFloatingUiActions(
        {
            placement: "bottom-start",
            //strategy: 'fixed',
        },
        8,
    );

    function showModal() {
        if ($roomListVisibilityStore) roomListVisibilityStore.set(false);

        if ($modalVisibilityStore) {
            modalVisibilityStore.set(false);
            modalIframeStore.set(null);
            return;
        }
        modalIframeStore.set({
            position: "center",
            src: "https://cubemeta.ru/spaces",
            allow: null,
            title: "Пространства",
            allowApi: true,
            allowFullScreen: true,
            closable: true,
        });
        modalVisibilityStore.set(true);
    }
</script>

{#if !inProfileMenu}
    <!-- svelte-ignore missing-declaration -->
    <ActionBarButton
        onclick={showModal}
        classList="group/btn-apps"
        context="actionBar"
        tooltipTitle={$LL.actionbar.help.apps.title()}
        disabledHelp={$openedMenuStore === "appMenu" || $roomListVisibilityStore}
        state={$openedMenuStore === "appMenu" || $roomListVisibilityStore ? "active" : "normal"}
        dataTestId="apps-button"
        action={floatingUiRef}
        media=""
        desc={$LL.actionbar.help.apps.desc()}
        label={$LL.actionbar.help.apps.title()}
        ariaLabel={$LL.actionbar.help.apps.title()}
    >
        <AppsLocationIcon />
    </ActionBarButton>
{:else}
    <ActionBarButton
        onclick={showModal}
        onkeydown={showModal}
        label={$LL.actionbar.help.apps.title()}
        classList="hidden narrow:flex"
        ariaLabel={$LL.actionbar.help.apps.title()}
    >
        <AppsLocationIcon />
    </ActionBarButton>
{/if}
